import { Popconfirm, Switch } from 'antd'

interface Props {
  checked: boolean
  target: string
  onLabel: string
  offLabel: string
  onConfirm: (next: boolean) => Promise<void>
  size?: 'small' | 'default'
}

// The switch never flips on click: the request fires only from the
// Popconfirm's action button, and the new state arrives via refetch.
export function ConfirmSwitch({
  checked,
  target,
  onLabel,
  offLabel,
  onConfirm,
  size,
}: Props) {
  const action = checked ? offLabel : onLabel

  return (
    // Stops row navigation; React bubbles portal (popup) clicks through here too.
    <span onClick={(e) => e.stopPropagation()}>
      <Popconfirm
        title={`${action} ${target}?`}
        okText={action}
        okButtonProps={{ danger: checked }}
        onConfirm={() => onConfirm(!checked)}
      >
        <Switch
          checked={checked}
          size={size}
          aria-label={`${action} ${target}`}
        />
      </Popconfirm>
    </span>
  )
}
